import HelpingList from "./HelpingList";
import { sendMessage } from "../../wsFunctions/socket";
import { listenToMessages } from "../../wsFunctions/socket";
import { useEffect } from "react";

function Tab0helperView(props) {
    useEffect(() => {
        console.log("useEffect executed tab0helperview");
        
        const dataFromBackend = listenToMessages((e) => {
            const type = e.data.type;
            console.log(type);
            
            if(type === "help-requests-added-request") {
                props.setCurrentlyHelping(e.data.data.currentlyHelping);
                props.setPendingHelp(e.data.data.pendingHelp);
                props.setLoading(false);
            };
        });

        sendMessage({type: "tab-0-opened", data: ''})
        return () => dataFromBackend();
    }, []);

    return (
        <>
            <div className="list-header-helper-page">
                <h1>Hjelpes akkurat nå</h1>
                <HelpingList setLoading={props.setLoading} list={props.currentlyHelping} helping={true} />
            </div>
            <div className="list-header-helper-page">
                <h1>Trenger hjelp</h1>
                <HelpingList setLoading={props.setLoading} list={props.pendingHelp} helping={false} />
            </div>
        </>
    );
};

export default Tab0helperView;